// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-payspace-payroll-and-hr-v2/form-item-payspace-payroll-and-hr-v2.component.scss
// module id = 1009
// module chunks = 0